// The planner's "Colour by" vocabulary, in one place so the toolbar control, the saved-view
// summary and the view rehydrate branch cannot drift apart.
//
// Order and copy are verbatim from Figma 294:6471. "Off" is the default even though it sits last
// in the option list.
export const DEFAULT_COLOUR_BY = "off";

export const COLOUR_BY_LABELS = {
  off: "Off",
  assignee: "Assignee",
  workflow_status: "Workflow status",
};
